import React, { FC, FocusEvent, SyntheticEvent } from 'react';
import { DropdownItemProps } from './DropdownList';
import { isEmpty, map } from 'lodash';

interface DropdownSelectProps {
  id: string;
  options: DropdownItemProps[];
  ariaLabelledby: string;
  ariaDescribedby: string;
  onChange?: (val: string, idx?: number) => void;
  onFocus?: (e: SyntheticEvent) => void;
  onBlur?: (e: string | FocusEvent) => void;
  error?: string;
}

const DropdownOption: FC<
  DropdownItemProps & {
    id: string;
    isSelected: boolean;
  }
> = ({ id, label, value, isDisabled, isSelected }) => {
  return (
    <option id={id} data-testid={id} value={value} disabled={isDisabled} aria-selected={isSelected}>
      {label}
    </option>
  );
};

export const DropdownSelect: FC<
  DropdownSelectProps & { isRequired: boolean; selectedIndex: number; isDisabled: boolean; value: string }
> = ({
  id,
  options,
  ariaLabelledby,
  ariaDescribedby,
  error,
  onChange,
  onFocus,
  onBlur,
  isRequired,
  selectedIndex,
  isDisabled,
  value
}) => {
  return (
    <select
      id={id}
      data-testid={`dropdown-${id}-select-button`}
      className={`drop-input drop-select ${!isEmpty(error) ? 'error' : ''}`}
      aria-label={ariaLabelledby}
      aria-labelledby={ariaLabelledby}
      aria-describedby={ariaDescribedby}
      aria-required={isRequired}
      aria-invalid={!isEmpty(error)}
      onChange={e => onChange(e.target.value, e.target.selectedIndex)}
      onFocus={onFocus}
      onBlur={onBlur}
      disabled={isDisabled}
      value={value}>
      {map(options, (option, idx: number) => (
        <DropdownOption
          {...option}
          id={`${id}-${option.value}`}
          key={`${id}-${option.value}-${idx}`}
          isSelected={selectedIndex === idx}
        />
      ))}
    </select>
  );
};

DropdownSelect.displayName = 'DropdownSelect';
